import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatStrikethrough12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextFormatStrikethrough12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 1h9v1.5a.5.5 0 0 1-1 0V2H7v2a.5.5 0 0 1-1 0V2H3v.5a.5.5 0 0 1-1 0zm5 8a.5.5 0 0 0-1 0v1H4.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H7zM3 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatStrikethrough12);
